import Knowledge from "../icons/Knowledge.png";
import KnowledgeDisabled from "../icons/KnowledgeDisabled.png";
import Solo from "../icons/Solo.png";
import SoloDisabled from "../icons/SoloDisabled.png";
import Team from "../icons/Team.png";
import TeamDisabled from "../icons/TeamDisabled.png";

export const getBadgeIconByChallengeType = (challengeType: string, isDisabled: boolean = false) => {
    switch (challengeType) {
        case "team":
            return isDisabled ? TeamDisabled : Team;
        case "solo":
            return isDisabled ? SoloDisabled : Solo;
        case "quiz":
            return isDisabled ? KnowledgeDisabled : Knowledge;
        default:
            return isDisabled ? SoloDisabled : Solo;
    }
};

export const getBadgeText = (challengeType: string) => {
    switch (challengeType) {
        case "team":
            return "Team challenge";
        case "solo":
            return "Solo challenge";
        case "quiz":
            return "Knowledge check";
        default:
            return "Challenge";
    }
};
